import './js/photoswipe/photoswipe.js';